<template>
  <div>
    <div class="h-full w-full flex flex-col mt-0 md:mt-12">
        <div class="w-full h-full flex flex-col md:flex-row flex-no-wrap md:flex-wrap">
            <div class="h-auto md:h-full w-full md:w-1/2 px-4 flex-auto">
                <form class="h-full flex flex-col items-center md:items-start" @submit.prevent="handleSubmit">
                    <div class="h-full flex flex-col wd-340 xs:wd-380 md:wd-auto">
                        <div class="w-full flex-auto overflow-y-scroll pr-0 md:pr-4 mt-2 md:mt-4">
                            <div class="flex flex-col">
                                <div class="flex flex-row flex-wrap">
                                    <div class="w-full flex justify-start ht-56 rsd-input br-28 items-center">
                                        <div class="h-full flex-shrink-0 flex items-center w-12 justify-center">
                                            <img :src="require('images/landing_page/modals/img1.svg')">
                                        </div>
                                        <div class="h-full flex-grow flex items-center pr-4">
                                            <input class="input-btn outline-none text-sm w-full" v-model.trim="enteredName.val" placeholder="Name" @keyup="clearValidity('enteredName')" autocomplete="off" required />
                                        </div>
                                    </div>
                                    <transition name="val-error">
                                        <p v-if="!enteredName.isValid" class="text-xs text-red">
                                            Name must not be empty.
                                        </p>
                                    </transition>
                                    <div class="w-full mt-4 flex justify-start ht-56 rsd-input br-28 items-center">
                                        <div class="h-full flex-shrink-0 flex items-center w-12 justify-center">
                                            <img :src="require('images/landing_page/modals/img2.svg')">
                                        </div>
                                        <div class="h-full flex-grow flex items-center pr-4">
                                            <input class="input-btn outline-none text-sm w-full" v-model.trim="enteredEmail.val" placeholder="Email" @keyup="clearValidity('enteredEmail')" autocomplete="off" required />
                                        </div>
                                    </div>
                                    <transition name="val-error">
                                        <p v-if="!enteredEmail.isValid" class="text-xs text-red">
                                            {{ enteredEmail.msg }}
                                        </p>
                                    </transition>
                                    <div class="w-full mt-4 flex justify-start ht-56 rsd-input br-28 items-center">
                                        <div class="h-full flex-shrink-0 flex items-center w-12 justify-center">
                                            <img :src="require('images/landing_page/modals/img3.svg')">
                                        </div>
                                        <div class="h-full flex-grow flex items-center pr-4">
                                            <input class="input-btn outline-none text-sm w-full" v-model.trim="enteredOrganizationName.val" placeholder="Organization Name" @keyup="clearValidity('enteredOrganizationName')" autocomplete="off" required />
                                        </div>
                                    </div>
                                    <transition name="val-error">
                                        <p v-if="!enteredOrganizationName.isValid" class="text-xs text-red">
                                            Organization Name must not be empty.
                                        </p>
                                    </transition>
                                </div>
                            </div>
                            <div class="flex flex-col mt-4">
                                <div class="flex flex-row flex-wrap mt-2">
                                    <div class="w-full">
                                        <div class="text-area-div p-4">
                                            <textarea maxlength="250" class="h-full w-full text-sm outline-none resize-none" placeholder="Leave a message here" v-model="enteredMessage.val" @keyup="clearValidity('enteredMessage')"/>
                                        </div>
                                        <transition name="val-error">
                                            <p v-if="!enteredMessage.isValid" class="text-xs text-red">
                                                Message must not be empty.
                                            </p>
                                        </transition>
                                    </div>
                                </div>
                            </div>

                            <div class="flex flex-col items-center sm:items-start mt-8 mb-4">
                            <!-- <div class="g-recaptcha" :data-sitekey="recaptchaSiteKey" @verify="onRecaptchaVerified"></div> -->
                            <vue-recaptcha ref="recaptcha" sitekey="6Leo2XsoAAAAAAFCEztEMeL2uA5hyj22FLrN-846" @verify="onVerify" @expired="onExpired"></vue-recaptcha>
                            </div>
                        </div>
                        <div class="flex flex-col items-center mt-4">
                            <div>
                                <transition name="val-error">
                                    <p class="text-sm text-red mb-2" v-if="serverResponse.val === '0'">{{ serverResponse.msg }}</p>
                                </transition>
                            </div>
                            <button type="submit" name="button" :class="formIsValid == true && verified_user == true ? 'bg-1' : 'bg-darkgrey'" class="py-2 rounded-xl justify-center items-center px-12 cursor-pointer">
                                <div class="flex justify-center text-white">Submit</div>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
export default {
    name: "investors-relations",
    components: {VueRecaptcha},
    props: {
    },
    created() {
    },
    computed: {
    },
    data() {
        return {
            enteredName: {
                val: "",
                isValid: true,
            },
            enteredEmail: {
                val: "",
                isValid: true,
                msg: "",
            },
            enteredOrganizationName: {
                val: "",
                isValid: true,
            },
            enteredMessage: {
                val: "",
                isValid: true,
            },
            serverResponse: {
                val: "",
                msg: "",
            },
            formIsValid: true,
            verified_user: false,
            recaptchaSiteKey:"6LeydXkoAAAAALmeNG1lDzk9qbBW7hjiDflqxHkZ",
        };
    },
    methods: {
        clearValidity(input) {
            this[input].isValid = true;
        },
        checkboxCilicked(index, status) {
            this.interests[index].isSelected = status;
        },
        validateForm() {
            this.formIsValid = true;
            this.serverResponse.val = "";
            if (this.enteredName.val === "") {
                this.enteredName.isValid = false;
                this.formIsValid = false;
            }
            if (this.enteredMessage.val === "") {
                this.enteredMessage.isValid = false;
                this.formIsValid = false;
            }
            if (this.enteredOrganizationName.val === "") {
                this.enteredOrganizationName.isValid = false;
                this.formIsValid = false;
            }
            if (this.enteredEmail.val === "") {
                this.enteredEmail.isValid = false;
                this.enteredEmail.msg = "Email must not be empty.";
                this.formIsValid = false;
            } else {
                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (!re.test(this.enteredEmail.val)) {
                    this.enteredEmail.isValid = false;
                    this.enteredEmail.msg = "You have entered an invalid email address!";
                    this.formIsValid = false;
                }
            }
        },
        handleSubmit() {
            this.validateForm();
            if (!this.formIsValid) {
                return;
            }

            const data = {
                name: this.enteredName.val,
                email: this.enteredEmail.val,
                organization_name: this.enteredOrganizationName.val,
                message: this.enteredMessage.val,
            };
            fetch("/investors_relations", {
                method: "POST",
                headers: {
                "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            })
            .then((response) => response.json())
            .then((data) => {
                this.serverResponse.val = data.code;
                this.serverResponse.msg = data.msg;
                if (data.code == "1") {
                    this.$swal({
                      title: '',
                      text: 'Thank you for reaching out. We’ll be in touch with you shortly!',
                      type: 'success',
                      showConfirmButton: true,
                    });
                    this.clearInputFields();
                } else {
                    this.serverResponse.val = "0";
                }
            })
            .catch((error) => {
                this.serverResponse.val = "0";
                this.serverResponse.msg = error;
            });
        },
        clearInputFields() {
            this.enteredName.val = "";
            this.enteredOrganizationName.val = "";
            this.enteredEmail.val = "";
            this.enteredMessage.val = "";
            this.serverResponse.val = "";
            this.serverResponse.msg = "";
        },

        onVerify(response) {
          // console.log('Verify: ' + response)
          if(response){
            this.verified_user = true
          }
        },

        onExpired(){
          this.verified_user = false
        }
    }
}
</script>

<style lang="scss" scoped>
    .fs-modal {
        background-color: #000000d6;
    }
    .rsd-input {
        border: 1px solid #ECECEC;
        background-color: white;
    }
    .input-btn {
        outline: 0;
    }
    .br-28 {
        border-radius: 28px;
    }
    .bg-1 {
        background: #8B40E2;
    }
    .text-area-div {
        height: 130px;
        background: #FFFFFF;
        border: 1px solid #ECECEC;
        border-radius: 28px;
    }
    .val-error-enter-active,
    .val-error-leave-active {
        transition: opacity 1s ease;
    }
    .val-error-enter, .val-error-leave-to {
        opacity: 0;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    .text-color-1 {
        color: #848186;
    }
    @responsive {
        .wd-525 {
            width: 525px;
        }
        .ht-56 {
            height: 56px;
        }
        .wd-389 {
            width: 389px;
        }
        .wd-309 {
            width: 309px;
        }
        .wd-225 {
            width: 225px;
        }
        .ht-260 {
            height: 260px;
        }
        .ht-auto {
            height: auto;
        }
        .lin-ht-36 {
            line-height: 36px;
        }
        .lin-ht-30 {
            line-height: 30px;
        }
        .w-100-per {
            width: 100%;
        }
        .wd-340 {
            width: 340px;
            max-width: 100%;
        }
        .wd-380 {
            width: 380px;
        }
        .wd-auto {
            width: auto;
        }
    }
</style>

<style lang="scss">
    .v--modal-box.v--modal {
        border-radius: 12px;
    }
    @media only screen and (max-width: 480px) {
        .static-modal-request-a-demo {
            .v--modal-background-click {
                .v--modal-box.v--modal {
                    margin-top: 40px !important;
                    margin-bottom: 40px !important;
                }
            }
        }
    }
</style>